import Fade from 'react-reveal/Fade';

export default function Testimonial() {
	return (
		<div className="relative mt-20">
			<div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:gap-24 lg:items-start">
				<Fade left>
					<div className="relative sm:py-16 lg:py-0">
						<div
							aria-hidden="true"
							className="hidden sm:block lg:absolute lg:inset-y-0 lg:right-0 lg:w-screen"
						>
							<div className="absolute inset-y-0 right-1/2 w-full bg-gray-50 rounded-r-3xl lg:right-72" />
							<svg
								className="absolute top-8 left-1/2 -ml-3 lg:-right-8 lg:left-auto lg:top-12"
								width={404}
								height={392}
								fill="none"
								viewBox="0 0 404 392"
							>
								<defs>
									<pattern
										id="02f20b47-fd69-4224-a62a-4c9de5c763f7"
										x={0}
										y={0}
										width={20}
										height={20}
										patternUnits="userSpaceOnUse"
									>
										<rect
											x={0}
											y={0}
											width={4}
											height={4}
											className="text-gray-200"
											fill="currentColor"
										/>
									</pattern>
								</defs>
								<rect width={404} height={392} fill="url(/yummu02f20b47-fd69-4224-a62a-4c9de5c763f7)" />
							</svg>
						</div>
						<div className="relative mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-0 lg:max-w-none lg:py-20">
							{/* Testimonial card*/}
							<div className="relative rounded-2xl shadow-xl overflow-hidden">
								<img
									className="h-full w-full"
									src={'https://source.unsplash.com/rEehwHlqKs0/1440x1440'}
									alt=""
								/>
								<div className="absolute inset-0 bg-rose-500 mix-blend-multiply" />
								<div className="absolute inset-0 bg-gradient-to-t from-rose-600 via-rose-600 opacity-30" />
							</div>
						</div>
					</div>
				</Fade>
				<Fade right>
					<div className="relative mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-0">
						{/* Content area */}
						<div className="pt-12 sm:pt-16 lg:pt-20">
							<h2 className="text-3xl text-gray-900 font-extrabold tracking-tight sm:text-4xl">
								We protect your digital content
							</h2>
							<div className="mt-6 text-gray-500 space-y-6">
								<p className="text-base leading-7">
									We help content creators and rights holders monetise their digital inventory on
									YouTube, we ensure that your content is being protected and generating revenue while
									you keep making the content you enjoy making.{' '}
								</p>
								<p className="text-base leading-7">
									Digital content protection is not only about your content, it’s about your brand.
									Therefore, an optimal content strategy with your brand at its core is crucial to
									strengthen and develop your online presence. At Noisely, we assist you from content
									planning, publishing over development to monetization.
								</p>
								<p className="text-base leading-7">
									We allow rights holders to submit their own content and audio tracks allowing them
									to manage the entire rights management process themselves. Our bulk submission tool
									allows you to protect your entire music and video library in a matter of minutes. We
									breakdown your earnings by each asset and for each claim.
								</p>
							</div>
						</div>
					</div>
				</Fade>
			</div>
		</div>
	);
}
